import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import ISubscription from "Types/Subscription";
import { State } from "store/reducers";
import ls from "Localization";

export const GET_SUBSCRIPTION = "[SUBSCRIPTION EDIT] GET_SUBSCRIPTION";
export const GET_SUBSCRIPTION_SUCCESS =
	"[SUBSCRIPTION EDIT] GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_FAILED =
	"[SUBSCRIPTION EDIT] GET_SUBSCRIPTION_FAILED";

export const EDIT_SUBSCRIPTION = "[SUBSCRIPTION EDIT] EDIT_SUBSCRIPTION";
export const EDIT_SUBSCRIPTION_SUCCESS =
	"[SUBSCRIPTION EDIT] EDIT_SUBSCRIPTION_SUCCESS";
export const EDIT_SUBSCRIPTION_FAILED =
	"[SUBSCRIPTION EDIT] EDIT_SUBSCRIPTION_FAILED";

export const SET_VALUE = "[SUBSCRIPTION EDIT] SET_VALUE";
export const CLEAR_VALUES = "[SUBSCRIPTION EDIT] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getSubscription(
	id: string,
	callback?: Callback<ISubscription>
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_SUBSCRIPTION });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Subscription/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_SUBSCRIPTION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SUBSCRIPTION_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_SUBSCRIPTION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateSubscription(callback?: Callback<ISubscription>) {
	return async (dispatch, getState) => {
		dispatch({ type: EDIT_SUBSCRIPTION });

		try {
			const state = getState();

			const { login, subscriptionEdit } = state;

			const {
				item,
				user,
				value,
				discount,
				installment,
				installmentInterval,
				description,
				status,
				plan,
				paymentMethod,
				firstPayment
			} = subscriptionEdit;

			const errors: any = {};
			if (!user) errors.user = ls.required;
			if (!value) errors.value = ls.required;
			if (!installment) errors.installment = ls.required;
			if (!plan) errors.plan = ls.required;
			if (!paymentMethod) errors.paymentMethod = ls.required;
			if (!firstPayment) errors.firstPayment = ls.required;

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {
				...item,
				value: Math.round(+value * 100),
				discount: Math.round(+discount * 100),
				installment,
				installmentInterval,
				description,
				status,
				plan,
				paymentMethod,
				firstPayment
			};

			const response = await api.sendPut("/Subscription/" + item._id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_SUBSCRIPTION_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_SUBSCRIPTION_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_SUBSCRIPTION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
